import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

export function CheckCircle({ color = "#408F42" }: { color: string }) {
  return (
    <Svg width={80} height={80} viewBox="0 0 80 80" fill="none">
      <Circle cx={40} cy={40} r={40} fill={color} />
      <Path
        d="M58.1014 27.8989L34.8688 51.1316L23.2524 39.5152"
        stroke="white"
        strokeWidth={5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}
